import React, { useContext } from 'react';
import { PageDataContext } from '../../providers/page-data-provider/index';
import getStyles from './styles';

const ProductGridError = (): JSX.Element => {
  const { error } = useContext(PageDataContext);

  return (
    <div id="product-grid-error" data-testid="product-grid-error" css={getStyles()}>
      {
        error
          ? "We're having a technical problem on this page. Refresh the page and try your search again."
          : 'There are currently no products that match your criteria. Please try again.'
      }
    </div>
  );
};

export default ProductGridError;
